import { Typography, useTheme } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { ServerPaginatedTable } from 'components/table';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { MessageDetailDialog } from './components/MessageDetailDialog';
import { DEFAULT_PAGE_SIZE } from 'constants/pagination.constants';
import { StateScope, SYSTEM_MESSAGES_INITIAL_SORT_BY, SYSTEM_MESSAGES_INITIAL_SORT_ORDER } from 'constants/system-messages.constants';
import * as TableConfig from './tablesConfig';
import { systemMessagesTableTypes } from './tables.types';
import { useSystemMessagesTable } from './hooks/useSystemMessagesTable';

export const SystemMessagesTable = () => {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const table = useSystemMessagesTable({ scope: StateScope.Global });

	return (
		<>
			<Typography variant="h6" sx={{ mb: 2, color: theme.palette.root.formTitle }}>
				{t('page.systemMessages.table.title')}
			</Typography>
			<Typography variant="subtitle" color={theme.palette.root.grey} sx={{ mb: 2 }}>
				{table.total + ' ' + t('messages.results')}
			</Typography>
			<ServerPaginatedTable
				rowsClass="alignTop"
				data={TableConfig.tableData(table.rows)}
				defaultSortBy={SYSTEM_MESSAGES_INITIAL_SORT_BY}
				defaultOrderBy={SYSTEM_MESSAGES_INITIAL_SORT_ORDER}
				columns={TableConfig.buildColumns(systemMessagesTableTypes.GLOBAL, t)}
				rowAction={table.handleRow}
				perPage={DEFAULT_PAGE_SIZE}
				serverPagination={{
					total: table.total,
					hasMore:
						table.rows.length === DEFAULT_PAGE_SIZE &&
						(table.currentPage + 1) * DEFAULT_PAGE_SIZE < table.total,
					currentPage: table.currentPage,
					onPageChange: table.handlePageChange,
					onSortChange: table.handleSortChange,
					isLoading: table.isLoading,
				}}
			/>
			<MessageDetailDialog
				open={table.detailOpen}
				onClose={table.closeDetail}
				onDisabled={table.refreshCurrentPage}
			/>
		</>
	);
};
